import Script from 'next/script';
import moment from 'moment';

const NewsSchema = ({ news }) => {
    // ISO 8601 格式
    const FormattedDate = (time) => {
        const formatTime = moment(time).tz('Asia/Taipei').format('YYYY-MM-DDTHH:mm:ssZ');

        return formatTime;
    };

    // 新聞參考資料
    const citation =
        news?.reference?.map((reference) => {
            const defaultReference = {
                '@type': 'CreativeWork',
                headline: reference?.content, // 引用文章標題
                url: reference?.link,
                publisher: {
                    '@type': 'Organization',
                    name: reference?.name,
                },
            };

            if (reference?.author)
                defaultReference.author = { '@type': 'Person', name: reference?.author };

            if (reference?.releasedTime)
                defaultReference.datePublished = FormattedDate(reference?.releasedTime);

            return defaultReference;
        }) || [];

    return (
        <>
            {/* faqPage schema */}
            {news?.faqTopic && (
                <Script
                    id="faq-schema"
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'FAQPage',
                            mainEntity: news?.faqTopic?.faqList.map((faq) => {
                                return {
                                    '@type': 'Question',
                                    name: faq.question,
                                    acceptedAnswer: {
                                        '@type': 'Answer',
                                        text: faq.answer,
                                    },
                                };
                            }),
                        }),
                    }}
                />
            )}

            {/* article schema */}
            <Script
                id="article-schema"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Article',
                        headline: news?.title,
                        description: news?.brief,
                        author: {
                            '@type': 'Person',
                            name: news?.reporter,
                            url: `https://www.cryptocity.tw/author/${news?.author}`,
                        },
                        image: news?.image, // 確保此欄位存在於 news 資料中
                        publisher: {
                            '@type': 'Organization',
                            name: 'CryptoCity 加密城市',
                            logo: {
                                '@type': 'ImageObject',
                                url: 'https://cdn.cryptocity.tw/assets/images/cc/v4/logo.svg',
                            },
                        },
                        datePublished: FormattedDate(news?.modifiedTime),
                        mainEntityOfPage: {
                            '@type': 'WebPage',
                            '@id': `https://www.cryptocity.tw/news/${news?.slug}`,
                        },
                        citation,
                    }),
                }}
            />

            {/* NewsArticle schema */}
            <Script
                id="news-article-schema"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'NewsArticle',
                        headline: news?.title,
                        description: news?.brief,
                        author: {
                            '@type': 'Person',
                            name: news?.reporter,
                            url: `https://www.cryptocity.tw/author/${news?.author}`,
                        },
                        url: `https://www.cryptocity.tw/news/${news?.slug}`,
                        image: news?.image,
                        publisher: {
                            '@type': 'Organization',
                            name: 'CryptoCity 加密城市',
                            logo: {
                                '@type': 'ImageObject',
                                url: 'https://cdn.cryptocity.tw/assets/images/cc/v4/logo.svg',
                            },
                        },
                        datePublished: FormattedDate(news?.modifiedTime),
                        mainEntityOfPage: {
                            '@type': 'WebPage',
                            '@id': `https://www.cryptocity.tw/news/${news?.slug}`,
                        },
                        citation,
                    }),
                }}
            />

            {/* BreadcrumbList schema */}
            <Script
                id="breadcrumb-list-schema"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'BreadcrumbList',
                        itemListElement: [
                            {
                                '@type': 'ListItem',
                                position: 1,
                                name: '首頁',
                                item: 'https://www.cryptocity.tw/',
                            },
                            {
                                '@type': 'ListItem',
                                position: 2,
                                name: '新聞',
                                item: 'https://www.cryptocity.tw/news',
                            },
                            {
                                '@type': 'ListItem',
                                position: 3,
                                name: news?.title,
                                item: `https://www.cryptocity.tw/news/${news?.slug}`,
                            },
                        ],
                    }),
                }}
            />
        </>
    );
};

export default NewsSchema;
